import React, { useEffect } from 'react';
import styled from 'styled-components';
import { OverlayAbsolute } from '/imports/ui/OverlayAbsolute';
import { BreadCrumb, setBreadcrumbs } from '/imports/ui/BreadCrumbs';
import { css } from '/imports/ui/css';

const PageStyled = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: auto;
  @media print {
    width: 100% !important;
  }
  ${css.mobileMedia} {
    width: 100%;
  }
`;

interface PageProps {
  className?: string,
  children: React.ReactNode,
  breadcrumbs?: BreadCrumb[],
  disabled?: boolean,
}

/** Scrollable page container that sets breadcrumbs and shows a disabled overlay. */
export const Page = (props: PageProps) => {
  useEffect(() => {
    if (props.breadcrumbs) setBreadcrumbs?.(props.breadcrumbs);
    else setBreadcrumbs?.([]);
  }, []);
  return (
    <PageStyled id="page" className={`page${props.className ? ` ${props.className}` : ''}`}>
      {props.children}
      {props.disabled && <OverlayAbsolute />}
    </PageStyled>
  );
};